
// Admin
export const ADMIN_SEARCHFILTER_ACTIONS = {
  // list
  SEARCHFILTER_LIST_REQUEST: "ADMIN_SEARCHFILTER_LIST_REQUEST",
  SEARCHFILTER_LIST_RESPONSE: "ADMIN_SEARCHFILTER_LIST_RESPONSE",
  SEARCHFILTER_LIST_ERROR: "ADMIN_SEARCHFILTER_LIST_ERROR",

  // create
  SEARCHFILTER_REQUEST: "SEARCHFILTER_REQUEST",
  SEARCHFILTER_RESPONSE: "SEARCHFILTER_RESPONSE",
  SEARCHFILTER_ERROR: "SEARCHFILTER_ERROR",

  //mark as featured search
  MARK_FEATURED_REQUEST: "MARK_FEATURED_REQUEST",
  MARK_FEATURED_RESPONSE: "MARK_FEATURED_RESPONSE",
  MARK_FEATURED_ERROR: "MARK_FEATURED_ERROR",

  // update
  SEARCHFILTER_EDIT_REQUEST: "SEARCHFILTER_EDIT_REQUEST",
  SEARCHFILTER_EDIT_RESPONSE: "SEARCHFILTER_EDIT_RESPONSE",
  SEARCHFILTER_EDIT_ERROR: "SEARCHFILTER_EDIT_ERROR",

  // delete
  SEARCHFILTER_DELETE_REQUEST: "SEARCHFILTER_DELETE_REQUEST",
  SEARCHFILTER_DELETE_RESPONSE: "SEARCHFILTER_DELETE_RESPONSE",
  SEARCHFILTER_DELETE_ERROR: "SEARCHFILTER_DELETE_ERROR",
};
